export const isValidGaiaIdentity = (gaiaObjectId: string) => {
  return (
    gaiaObjectId.match(
      /^(audit|notice|litigation)[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}|[A-Z]\d{7}$/
    ) !== null
  );
};

export const isValidBrazilCpf = (id: string | undefined) => {
  return id && id.match(/^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/) !== null;
};

export const isValidBrazilCnpj = (id: string | undefined) => {
  return id && id.match(/^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/) !== null;
};

export const hasMoreThanTenIds = (data: string | undefined) => {
  throw new Error("Function not implemented.");
};

export const validateField = (
  value: string,
  fieldName: string,
  maxLength: number,
  invalidChars: RegExp
) => {
  if (!value.trim()) {
    return `${fieldName} is required`;
  }
  if (value.length > maxLength) {
    return `${fieldName} cannot exceed ${maxLength} characters`;
  }

  if (invalidChars.test(value)) {
    return `${fieldName} contains invalid characters`;
  }
  return "";
};

// CSV Formula Injection Prevention - addresses CWE-1236
const FORMULA_INJECTION_CHARS = new Set([
  "=",
  "+",
  "-",
  "@",
  "*",
  "/",
  "^",
  "|",
  "\t",
  "\r",
]);

export function sanitizeForCSV(value: any): any {
  if (typeof value !== "string") {
    return value;
  }
  if (value.length === 0) {
    return value;
  }

  const firstChar = value.charAt(0);
  if (FORMULA_INJECTION_CHARS.has(firstChar)) {
    return `'${value}`;
  }

  return value;
}
